module.exports = __webpack_public_path__ + "static/img/menu7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu7.png
// module id = 561
// module chunks = 0